<a [attr.href]="floatingButtonLink" [attr.target]="floatingButtonTarget" rel="noopener noreferrer"
	[style]="'bottom: calc(50% - ' + (btnPosition * 60) + 'px)'" (click)="floatingButtonClick($event)"
	nzTooltipTitle="{{ btnTitle | translate }}" nzTooltipPlacement="left" nz-tooltip class="cui__sidebar__toggleButton">
	<i-feather name="{{ btnIcon }}"></i-feather>
</a>
